import { render, staticRenderFns } from "./EditDeliveryAddressModal.vue?vue&type=template&id=49bf84fa"
import script from "./EditDeliveryAddressModal.vue?vue&type=script&lang=ts"
export * from "./EditDeliveryAddressModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports